// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/modules/products/v2_0/components/RecallAlert/recallAlert.scss
// module id = 1365
// module chunks = 10